import React from 'react';
import { useIntl } from 'ha/i18n';

import { Box } from '@hbf/dsl';
import { PhotoPlaceholder } from 'ha/components/PhotoPlaceholder';

import CannotLoadMap from 'ha/custom-icons/cannot-load-map.svg';

const ListingMapErrorPlaceholder: React.FC = () => {
  const { T } = useIntl();

  return (
    <Box width="inherit" height="inherit">
      <PhotoPlaceholder
        IconComponent={CannotLoadMap}
        text={T(`Couldn't load the map. Please try again.`)}
      />
    </Box>
  );
};

export { ListingMapErrorPlaceholder };
